import { JOB_STEPS_BACKEND } from "@/constants/common/jobs-steps";
import { SidebarAction } from "@/imports-files/components/sidebar";

export function goToNextPage(key, setPageName, queryClient, link)
{
    if(event != undefined) {event.preventDefault(); }
    queryClient.setQueryData('selectedSubSidebarOptions', () => key);
    // window.history.replaceState(null, null, link);
    window.history.pushState(null, null, link);
    setPageName(key);
}


export function sendToCurrentSteps(...args)
{

    var current_step_index   =   args[0];
    var job_id               =   args[1] 
    var options              =   args[2][0]; 
    var queryClient          =   args[3]; 
    var setPageName          =   args[4]; 
    var sidebarKey           =   args[5];     
    var SidebarOption        =   options[sidebarKey].subSidebar_options;
    var keys_array           =   Object.keys(SidebarOption);
    var setPageName          =   args[4]; 
   
    if( url_step_is_greater_than_current_step(current_step_index) )
    {
        redirect_to_current_step(current_step_index, job_id, keys_array, queryClient, setPageName, SidebarOption)
    }
}


function redirect_to_current_step(current_step_index, job_id, keys_array, queryClient, setPageName, SidebarOption)
{
    var key                  =   null;
    var link                 =   null;
    var index                =   current_step_index;

 
    for(let value of keys_array)
    {
        if(SidebarOption[value].step == index)
        {   
            key  =  value;
            link = replace_id(SidebarOption[value].link, job_id);
            nextPage(key, setPageName, queryClient, link)
            break;
        }
    }
}

function replace_id(url, id)
{
    var urlArray = url.split('/');
    for( let element of urlArray)
    {
        if(element.startsWith('$'))
        {
            var index  = urlArray.indexOf(element);
            urlArray[index] = id;
            break
        }
    }
    return urlArray.join('/');
}

function nextPage(key, setPageName, queryClient, link)
{
    queryClient.setQueryData('selectedSubSidebarOptions', () => key);
    window.history.replaceState(null, null, link);
    setPageName(key);
}

function url_step_is_greater_than_current_step(current_step_index)
{
    var url_step_index           =   current_url_index();
    return url_step_index > current_step_index ;
}

function current_url_index()
{
    var url_arr         =   window.location.pathname.split('/');
    var next_val        =   url_arr[url_arr.length -1];

    return JOB_STEPS_BACKEND[next_val];
}